<script setup lang="ts">
import { onMounted } from 'vue';
import mobileDetectStore from '@src/application/store/mobile-detect-store.js';

const props = withDefaults(defineProps<{
    component: string|object,
    resolveListener: string|null,
    props?: object,
}>(), {
    props: () => {
        return {};
    },
});

const emit = defineEmits<
    ((event: string, value: any) => void)
    &((event: 'reject') => void)
>();

onMounted(() => {
    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') {
            return;
        }
        emit('reject');
    });
});

function closeModal() {
    if (mobileDetectStore.isMobile.data) {
        return;
    }
    emit('reject');
}
</script>

<template>
    <div>
        <div :class="$style.modal_abort">
            <component
                :is="component"
                v-if="resolveListener !== null"
                v-bind="props.props"
                @[resolveListener]="
                    // @ts-ignore
                    emit(resolveListener, $event)
                "
            />
            <component :is="component" v-else v-bind="props.props"/>
            <div :class="$style.button_close" @click="emit('reject')">
                <span :class="[$style.x_line, $style.one]"/>
                <span :class="[$style.x_line, $style.two]"/>
            </div>
        </div>
        <div :class="$style.layer" @click="closeModal"/>
    </div>
</template>

<style lang="scss" module>
    .button_close {
        position: fixed;
        top: 1px;
        right: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3em;
        height: 3em;
        cursor: pointer;
        background-color: rgba(10, 13, 16, 85%);
        border: 1px solid #aeaeae;

        .x_line {
            width: 1px;
            height: 60%;
            background-color: #eee;
        }
        .one {
            transform: rotate(45deg);
        }
        .two {
            transform: rotate(-45deg);;
        }
    }
    .modal_abort {
        position: relative;
        z-index: 1;
    }
    .layer {
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1;
        display: block;
        width: 100vw;
        height: 100vh;
        content: "";
    }
</style>
